<template>
  <v-card>
    <video controls style="max-width: 100%" v-if="instructionVideoSrc">
      <source :src="instructionVideoSrc" type="video/mp4" />
    </video>
    <v-img :src="instructionPicturesImages[0]" height="250" v-else-if="hasOneImage" />
    <v-carousel height="250" continuous cycle delimiter-icon="mdi-minus" v-else-if="hasMultipleImages">
      <v-carousel-item
        v-for="(item, i) in instructionPicturesImages"
        :key="i"
        :src="item"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>

    <v-card-title>
      {{ $t(instructionTitle) }}
    </v-card-title>

    <v-card-text v-html="$t(instructionText)"> </v-card-text>

    <v-card-actions>
      <v-btn @click="clicked" elevation="0" class="px-4" block x-large data-test-instruction-understood>
        {{ $t("gotIt") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import { AssetRepository, AssetEnum } from "@/lib/AssetRepository";

@Component
export default class InstructionCard extends Vue {
  @Prop({ default: "Anleitung" })
  instructionTitle!: string;

  @Prop()
  instructionText!: string;

  @Prop()
  instructionPictures!: AssetEnum[];

  @Prop()
  instructionImageSrcs?: string[];

  @Prop()
  instructionVideoSrc?: string;

  clicked() {
    this.$emit("clicked", true);
  }

  get hasOneImage(): boolean {
    if (this.instructionImageSrcs) {
      return this.instructionImageSrcs.length == 1;
    }

    if (this.instructionPictures) {
      return this.instructionPictures.length == 1;
    }

    return false;
  }

  get hasMultipleImages(): boolean {
    if (this.instructionImageSrcs) {
      return this.instructionImageSrcs.length >= 2;
    }

    if (this.instructionPictures) {
      return this.instructionPictures.length >= 2;
    }

    return false;
  }

  get instructionPicturesImages(): string[] {
    const images: string[] = [];

    if (this.instructionImageSrcs) {
      return this.instructionImageSrcs;
    }

    if (!this.instructionPictures) {
      return images;
    }

    for (const picture of this.instructionPictures) {
      const asset = AssetRepository.getAsset(this.$vuetify.theme.dark, picture);
      images.push(asset);
    }

    return images;
  }
}
</script>

<style></style>
